import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addBrandCompetition, addProduct, getBrandCompetition, getBrandData, getCategoryData, getPackagingData, getProductList, getSingleBrandCompetition, getSingleProductData, getTagsData, updateBrandCompetition, updateProduct } from "./ProductRepository";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

export const useProductList=({
    params={},
    enable=false
})=>{
    return useQuery({
        queryKey:["GET_PRODUCT_LIST",params],
        queryFn:()=>getProductList(params),
        enabled:enable,
        retry:false
    })
}


export const useSingleProduct=({
    id,
    enable=false,
}:{
    id:number;
    enable:boolean

})=>{
    return useQuery({
        queryKey:["GET_PRODUCT_LIST",id],
        queryFn:()=>getSingleProductData(id),
        enabled:enable,
        retry:false
    })
}


export const useBrandList=({params={},enable=false})=>{
    return useQuery({
        queryKey:["GET_BRAND_LIST",params],
        queryFn:()=>getBrandData(params),
        enabled:enable,
        retry:false
    })
}

export const useCategoryList=({
    params={},
    enable=false
})=>{
    return useQuery({
        queryKey:["GET_CATEGORY_LIST",params],
        queryFn:()=>getCategoryData(params),
        enabled:enable,
        retry:false
    })
}

export const useTagList=({
    enable=false
})=>{
    return useQuery({
        queryKey:["GET_TAG_LIST"],
        queryFn:()=>getTagsData(),
        enabled:enable,
        retry:false
    })
}

export const usePackageList=({
    enable=false
})=>{
    return useQuery({
        queryKey:["GET_PACKAGE_LIST"],
        queryFn:()=>getPackagingData(),
        enabled:enable,
        retry:false
    })
}

 export const useGetBrandCompetitionList = ({
    enabled,
    params,
    id
    
  }: {
    enabled: boolean;
    params?:Record<string,any>
    id:number
  }) => {
    return useQuery({
      queryKey: ["GET_BRAND_COMPETITION", params,id],
      queryFn: () => getBrandCompetition(params ?? {}, id),
      enabled,
      retry: false,
    });
  };

 export const useGetSingleBrandCompetitor = ({
    enabled,
    params,
    id
    
  }: {
    enabled: boolean;
    params?:Record<string,any>
    id:number
  }) => {
    return useQuery({
      queryKey: ["GET_SINGLE_BRAND_COMPETITOR", params,id],
      queryFn: () => getSingleBrandCompetition(params ?? {}, id),
      enabled,
      retry: false,
    });
  };

  export const useAddProduct =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addProduct(reqBody),
    
    
    onSuccess:()=>{
        showToast.success("Product Added");
          queryClient.invalidateQueries({ queryKey: ["GET_PRODUCT_LIST"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Data:", error.message)
    }
      
   })
} 

  export const useUpdateProduct =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:({reqBody,id}:{reqBody:any,id:number})=>updateProduct(reqBody,id),
    
    
    onSuccess:()=>{
        showToast.success("Product Updated");
          queryClient.invalidateQueries({ queryKey: ["GET_PRODUCT_LIST"] });
    },
    onError:(error:any)=>{
    console.warn("Failed to Update Data:", error.message)
    }
      
   })
} 


 export const useAddBrandCompetitor =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addBrandCompetition(reqBody),
    
    
    onSuccess:()=>{
        showToast.success("Brand Competitor Added");
          queryClient.invalidateQueries({ queryKey: ["GET_BRAND_COMPETITION"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Data:", error.message)
    }
      
   })
} 


 export const useUpdateBrandCompetitor =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:({reqBody,id}:{reqBody:any,id:number})=>updateBrandCompetition(reqBody,id),
    
    
    onSuccess:()=>{
        showToast.success("Brand Competitor Updated");
          queryClient.invalidateQueries({ queryKey: ["GET_BRAND_COMPETITION"] });
          queryClient.invalidateQueries({ queryKey: ["GET_SINGLE_BRAND_COMPETITOR"] });
          
    },
    onError:(error:any)=>{
    console.warn("Failed to Update Data:", error.message)
    }
      
   })
} 